
import { styled } from "@mui/styles";
import {
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

export const ActionBtn = styled(Button)(() => ({
  borderRadius: "4px",
  textTransform: "capitalize",
  padding: "4px 18px",
  backgroundColor: "#638DFF",
  color: "#FFFFFF",
  fontFamily: "Roboto, sans-serif",
  fontWeight: 600,
  fontSize: 12,
  boxShadow: "none",
  "&:hover": { backgroundColor: "#638DFF" },
  "&:focus": { boxShadow: "0 0 6px 0 #638DFF !important" },
  "&:disabled": {
    backgroundColor: "#aeb8d6",
    color: "#e8ecf8",
  },
}));

export const CssTextField = styled(TextField)(() => ({
  margin: 0,
  backgroundColor: "#ffffff",
  borderRadius: "4px",
  width: "170px",
  "& .MuiInputBase-root": { padding: "1px" },
  "& .MuiIconButton-root": { padding: "4px" },
  "& input": {
    height: "auto",
    padding: "9px",
    fontSize: "14px",
    color: "#44485A",
  },
  "& .MuiIconButton-root": {
    padding: "18px",
  },
}));

export const Label = styled(Typography)(() => ({
  minWidth: "60px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "-0.36px",
  color: "#2a2d3c",
}));

export const IconButtonContainer = styled(IconButton)(() => ({
  display: "flex",
  justifyContent: "center",
  width: "20px",
  height: "20px",
  padding: "2px",
  objectFit: "contain",
  borderRadius: "6px",
}));

export const TodayBtn = styled(Button)(() => ({
  width: "70px",
  height: "30px",
  fontSize: "12px",
  borderRadius: "6px",
  border: "solid 1.2px #e8e8e8",
  backgroundColor: "#ffffff",
  textTransform: "capitalize",
  color: "rgba(0, 0, 0, 0.87)",
  "&:hover": { border: "none" },
}));

export const FormControlContainer = styled(FormControl)(() => ({
  backgroundColor: "#ffffff",
  borderRadius: "4px",
  textTransform: "capitalize",
  margin: "0px",
  "& .MuiSelect-root": {
    color: "#44485A",
    fontSize: "14px",
    padding: "2px 10px",
    "&:focus": { background: "#fff" },
  },
}));

export const SelectContainer = styled(Select)(() => ({
  "& .MuiSelect-select": {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
    paddingLeft: "4px",
    fontSize: 14,
  },
}));

export const MenuItemContainer = styled(MenuItem)(() => ({
  textTransform: "capitalize",
}));